import { useEffect, useState } from "react";
import PieChart from "../charts/PieChart";

export default function AksesSumberDaya({ data }) {
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: []
  })

  useEffect(() => {
    const mapData = {}
    const rawData = {
      labels: [],
      datasets: [
        {
          label: '',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 0.8)',
            'rgba(4,135,55, 0.6)',
            'rgba(4,135,55, 0.3)',
            'rgba(4,135,55, 0.2)',
            'rgba(4,135,55, 0.1)',
          ],
          borderColor: [
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };
    data.map(item => {
      if(item["akses_sda_selama_covid19"] === 2){
        if (mapData["Sama saja"] !== undefined) {
          mapData["Sama saja"] += 1
        }else{
          mapData["Sama saja"] = 1;
        }
      }else if(item["akses_sda_selama_covid19"] === 3){
        if (mapData["Lebih susah"] !== undefined) {
          mapData["Lebih susah"] += 1
        }else{
          mapData["Lebih susah"] = 1;
        }
      }else if(item["akses_sda_selama_covid19"] === 1){
        if (mapData["Lebih mudah"] !== undefined) {
          mapData["Lebih mudah"] += 1
        }else{
          mapData["Lebih mudah"] = 1;
        }
      }
      return item
    })
    rawData.labels = Object.keys(mapData)
    rawData.datasets[0].data = []
    rawData.labels.map(item => {
      rawData.datasets[0].data.push(((mapData[item]/data.filter(item => Number.isInteger(item["akses_sda_selama_covid19"])).length)*100).toFixed(1))
      return item
    })
    setGraphData(rawData)
  }, [data]);

  return <PieChart data={graphData} />
}